import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { ChronosDate } from "../../_helpers";
import { Icon } from "../Icon";

const DEFAULT_DATE_MASK = `$DD$ $MMMM$ $YYYY$`;

export function CalendarPickerInput(props) {
  const { details: world } = useSelector((state) => state.world);
  //Destructure the values
  const {
    date, //Object representing the date
    calendar, //Calendar object to use in parsing
    isDropdownOpen, //Boolean of dropdown status
    toggleDropdown, //Function to toggle dropdown status
    clearDate, //Function to clear the date value (-> null)
    dateMask, //Custom Date mask to format date by
    placeholder, //Placeholder string
    disabled, //Is the "input" disabled?
    isUnset, //Is the date modified but not set to form value?
  } = props;

  //Set state of the displayed text
  const [displayText, setDisplayText] = useState(placeholder || "");
  //Intermediate function to handle dropdown toggling
  const handleDropdownToggle = () => {
    if (!disabled) {
      if (toggleDropdown) toggleDropdown();
    }
  };

  //Intermediate funtion to handle clearing the date
  const handleClearPress = (ev) => {
    if (!disabled) {
      if (clearDate) clearDate(ev);
    }
  };

  //Function to format the date
  useEffect(() => {
    // console.log('Date Render', date);
    formatDate(date);
  }, [date]);

  const formatDate = (dateVal) => {
    let customDateMask = dateMask || calendar.dateMask || DEFAULT_DATE_MASK;
    if (date !== null) {
      let posSuffix = "";
      let negSuffix = "";
      if (world && world.worldTime) {
        let postAbbr = world.worldTime.afterZeroAbbr;
        let preAbbr = world.worldTime.beforeZeroAbbr;
        if (postAbbr && postAbbr.length > 0) {
          // console.log('WORLD TIME CONFIG:', world.worldTime);
          posSuffix = postAbbr;
        }
        if (preAbbr && preAbbr.length > 0) {
          negSuffix = preAbbr;
        }
      }
      // console.warn('New Date', newDate);
      // console.log('Formatting Date');
      const tempDate = new ChronosDate("0", { calendar, logSteps: true });
      const formattedDate = tempDate.format(
        customDateMask,
        dateVal,
        posSuffix,
        negSuffix
      );

      // console.log(
      //   'FORMATTER: Date Input: Date Changed',
      //   dateVal,
      //   formattedDate
      // );
      setDisplayText(formattedDate);
      return;
    }
    setDisplayText(placeholder ? placeholder : "");
  };

  // console.log('Date Picker Input (HERE): ', date, displayText);
  // console.log('Dropdown is opened?', isDropdownOpen);
  return (
    <div
      className="chronos-calendar-date-picker-control"
      onClick={handleDropdownToggle}
      // style={{ borderColor: isUnset ? 'red' : '#ccc' }}
    >
      <div className="calendar-date-picker-display">{displayText}</div>
      <div className="calendar-date-picker-options">
        {clearDate && date !== null && (
          <span
            className="calendar-date-picker-clear-btn"
            onClick={handleClearPress}
          >
            <Icon icon="far fa-times" />
          </span>
        )}
        <span
          className="calendar-date-picker-dropdown-toggle"
          // onClick={handleDropdownToggle}
        >
          {isDropdownOpen && <Icon icon="far fa-chevron-up" />}
          {!isDropdownOpen && <Icon icon="far fa-chevron-down" />}
        </span>
      </div>
    </div>
  );
}
